import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  isPatientTasksMigrated: false,
  data: [],
  loading: false,
  isError: false,
};

export const migrateTherapistPatientReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.MIGRATE_THERAPIST_PATIENT_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isPatientTasksMigrated: true,
        data: action.payload.data,
        loading: false,
        isError: false,
      };
    }
    case TherapistAction.MIGRATE_THERAPIST_PATIENT_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isPatientTasksMigrated: false,
        loading: false,
        isError: true,
      };
    }
    case TherapistAction.MIGRATE_THERAPIST_PATIENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case TherapistAction.MIGRATE_THERAPIST_PATIENT_RESET:
      return {
        ...state,
        response: null,
      };

    default:
      return state;
  }
};
